import React, { Component } from 'react';
import { Link } from 'react-router';

import MenuItem from 'material-ui/MenuItem';
import InfoIcon from 'material-ui/svg-icons/action/info-outline';
import Drawer from 'material-ui/Drawer';

class GuestDrawer extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            open: false
        };
    }

    render() {
        return (
                <Drawer
                    className="cent-drawer"
                    docked={false}
                    open={this.props.open}
                    onRequestChange={this.props.onRequestChange}
                >
                    <MenuItem
                        onTouchTap={this.props.onRequestChange}
                        value='Sign in'
                        label='Sign in'
                        leftIcon={<InfoIcon />}
                    >
                        <Link to='/dashboard/logout'>Sign in</Link>
                    </MenuItem>

                </Drawer>
        )
    }
}

export default GuestDrawer;
